// Device identity is one localStorage entry per draft: fd:{code}:teamToken.
// The commissioner URL itself is the commissioner credential — nothing is
// stored for it. localStorage can throw (private mode, disabled); a party
// tool should shrug, not crash.

const teamTokenKey = (code: string) => `fd:${code.toUpperCase()}:teamToken`

export function getTeamToken(code: string): string | null {
  try {
    return localStorage.getItem(teamTokenKey(code))
  } catch {
    return null
  }
}

export function setTeamToken(code: string, token: string): void {
  try {
    localStorage.setItem(teamTokenKey(code), token)
  } catch {
    // Claiming still worked server-side; the user just won't be remembered.
  }
}

export function clearTeamToken(code: string): void {
  try {
    localStorage.removeItem(teamTokenKey(code))
  } catch {
    // ignore
  }
}

// The admin token is a deploy-wide secret typed into whatever laptop is
// running draft night, so it goes in sessionStorage rather than localStorage:
// closing the tab forgets it.
const ADMIN_TOKEN_KEY = 'fd:adminToken'

export function getAdminToken(): string | null {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_KEY)
  } catch {
    return null
  }
}

export function setAdminToken(token: string): void {
  try {
    sessionStorage.setItem(ADMIN_TOKEN_KEY, token)
  } catch {
    // The token still works for this page load; it just won't survive a reload.
  }
}

export function clearAdminToken(): void {
  try {
    sessionStorage.removeItem(ADMIN_TOKEN_KEY)
  } catch {
    // ignore
  }
}
